import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const cards = [
  {
    label: "01",
    title: "Diagnose",
    subheading: "Something isn't working. Let's understand why.",
    body: [
      "A focused engagement to look at your brand, your positioning, and your growth engine from the outside, and work out what actually needs attention.",
      "You leave with a clear diagnosis, priorities and a roadmap for what to do next.",
    ],
    note: "Fixed scope. Defined output.",
    cta: "Start here",
    accent: "#F2C14E",
  },
  {
    label: "02",
    title: "Consult",
    subheading: "You need someone senior marketer in the room.",
    body: [
      "GroundWork works alongside founders and leadership teams to shape brand and marketing strategy, make decisions, prioritise resources, and keep growth moving in the right direction.",
    ],
    note: "Ongoing strategic support.",
    cta: "Talk to us",
    accent: "#E26D5C",
  },
  {
    label: "03",
    title: "Growth Partner",
    subheading: "You want someone to take your marketing forward.",
    body: [
      "Once the direction is clear, we can stay on and help make it happen. We bring together the right people across brand, creative, performance and growth, and lead the work around one clear roadmap.",
    ],
    note: "Strategy, execution and accountability.",
    cta: "Build with us",
    accent: "#729B79",
  },
];

export default function HowWeWork() {
  return (
    <section
      id="how-we-work"
      data-testid="how-we-work-section"
      className="scroll-mt-24 bg-[#F7F5F0] py-24 md:py-40 border-t border-[#D8D4C7]"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 mb-16 md:mb-20">
          <div className="md:col-span-3 reveal">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#5C5C58]">
              (02) · How we work
            </span>
            <div className="mt-6 w-12 h-px bg-[#1C1C19]" />
          </div>
          <div className="md:col-span-9 reveal">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight leading-[1.05] text-[#1C1C19]">
              Understand. Advise. <span className="italic text-[#729B79]">Grow.</span>
            </h2>
            <p className="mt-8 max-w-2xl text-base md:text-lg font-light text-[#1C1C19]/70">
              Start with what you need today. If the work calls for something
              more, we'll figure that out together.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {cards.map((c, i) => (
            <a
              key={c.label}
              href="#contact"
              data-testid={`how-we-work-card-${i + 1}`}
              style={{ borderTopWidth: 4, borderTopColor: c.accent }}
              className="reveal group flex flex-col rounded-2xl border border-[#D8D4C7] bg-white p-8 md:p-10 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl"
            >
              <span
                className="font-display text-5xl font-light leading-none"
                style={{ color: c.accent }}
              >
                {c.label}
              </span>
              <h3 className="mt-6 font-display text-3xl md:text-4xl font-light tracking-tight text-[#1C1C19]">
                {c.title}
              </h3>
              <p className="mt-3 text-sm font-medium text-[#1C1C19]/70">
                {c.subheading}
              </p>
              <div className="mt-5 flex-1 space-y-3 text-base font-light leading-relaxed text-[#1C1C19]/70">
                {c.body.map((p) => (
                  <p key={p}>{p}</p>
                ))}
              </div>
              <span className="mt-6 text-[11px] uppercase tracking-[0.2em] text-[#5C5C58]">
                {c.note}
              </span>
              <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-widest transition-all duration-500 group-hover:gap-3" style={{ color: c.accent }}>
                {c.cta}
                <ArrowUpRight size={15} />
              </span>
            </a>
          ))}
        </div>

        <div className="mt-12 md:mt-16 reveal">
          <Link
            to="/approach"
            data-testid="how-we-work-see-more"
            className="link-underline inline-flex items-center gap-2 text-sm font-medium text-[#1C1C19]"
          >
            See how we work together
            <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
